"use strict";var e=require("react"),o=require("./styled-components.esm-cjs-3ahxUAxf.js"),a=require("react/jsx-runtime");const s=o.d.div`
  body {
    background-color: #f7f7f9;
    font-family: 'Montserrat', 'Nunito', 'sans-serif';
    color: #000;
  }

  .lp-container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
  }

  .lp-container img {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .lp-rounded {
    border-radius: 8px;
    overflow: hidden;
  }

  @media (min-width: 768px) {
    .lp-rounded {
      border-radius: 14px;
    }
  }

  /* Agrega este bloque para que la imagen se ajuste correctamente */
  .lp-rounded img {
    width: 100%;
    height: auto;
    display: block;
  }

  .lp-section {
    padding: 20px 0;
    max-width: 1000px;
    margin: 0 auto;
  }

  @media (min-width: 768px) {
    .lp-section {
      padding: 30px 0;
    }
  }

  .lp-section h1 {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 20px;
  }

  .lp-section p {
    text-align: justify;
    margin-bottom: 20px;
    margin-top: 0;
    line-height: 1.5em;
  }

  .form-box {
    background-color: #eaebed;
    padding: 30px;
    border-radius: 14px;
    margin: 30px 0;
    display: grid;
    gap: 20px;
    max-width: 100%;
    overflow: hidden;
  }

  .form-box input,
  .form-box select,
  .form-box textarea {
    font-family: 'Montserrat', 'Nunito', 'sans-serif';
    background-color: transparent;
    border: none;
    padding: 10px 0;
    border-bottom: 2px solid #b0afb4;
    font-size: 16px;
    font-weight: 500;
    max-width: 100%;
  }

  @media (min-width: 768px) {
    .form-box {
      border-radius: 20px;
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .form-box textarea {
      grid-column: span 3 / span 3;
    }
  }

  .submit-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    flex-wrap: wrap;
  }

  .btn {
    border: none;
    background-color: #cb060f;
    padding: 13px 30px;
    border-radius: 8px;
    color: #fff;
    text-transform: uppercase;
    font-weight: 700;
    cursor: pointer;
    text-align: center;
    font-size: 16px;
    margin: 0;
    text-decoration: none;
  }

  .divider {
    width: 100%;
    height: 2px;
    background-color: #dfdfdf;
    margin: 30px 0;
  }

  .loader {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
  }

  .loader .loader__inner {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .loader .loader__content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .loader .spinner {
    width: 75px;
    height: 75px;
    display: inline-block;
    border-width: 2px;
    border-color: rgba(255, 255, 255, 0.05);
    border-top-color: #fff;
    animation: spin 1s infinite linear;
    border-radius: 100%;
    border-style: solid;
  }

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`,t=o.d.div`
  display: ${({$show:e})=>e?"block":"none"};
`;exports.default=()=>{const[o,i]=e.useState(!1);e.useEffect((()=>{const e=document.createElement("script");return e.src="https://www.google.com/recaptcha/api.js",e.async=!0,e.defer=!0,document.body.appendChild(e),()=>{document.body.removeChild(e)}}),[]);return a.jsxs(s,{children:[a.jsx("main",{children:a.jsxs("div",{className:"lp-container",children:[a.jsx("div",{className:"lp-rounded",children:a.jsxs("picture",{children:[a.jsx("source",{media:"(min-width: 768px)",srcSet:"https://www.luiztonin.com.br/ecommerce/lps/canal-de-protecao-de-dados/Banner_Canal_Protecao_Dados_1700x180px_DESK.png"}),a.jsx("source",{media:"(max-width: 768px)",srcSet:"https://www.luiztonin.com.br/ecommerce/lps/canal-de-protecao-de-dados/Banner_Canal_Protecao_Dados_900x180px_MOBILE.png"}),a.jsx("img",{src:"https://www.luiztonin.com.br/ecommerce/lps/canal-de-protecao-de-dados/Banner_Canal_Protecao_Dados_1700x180px_DESK.png",alt:"Canal de Proteção de Dados",className:"img-fluid w-100"})]})}),a.jsx("div",{className:"divider"}),a.jsxs("section",{style:{paddingTop:"10px"},className:"lp-section",children:[a.jsx("p",{children:"Este Canal é de uso exclusivo para dúvidas e solicitações sobre seus dados pessoais como: confirmação da existência de tratamento de seus dados pessoais, solicitação de correção, eliminação, bloqueio ou atualização de seus dados pessoais do nosso banco de dados ou revogar consentimento de uso de seus dados pessoais. Para outros assuntos, utilize o canal Central de atendimento."}),a.jsxs("form",{id:"cpd-form",onSubmit:async e=>{e.preventDefault(),i(!0);const o=window.grecaptcha.getResponse();if(!o)return alert("Por favor, completa el reCAPTCHA."),void i(!1);const a=new FormData(e.target);a.append("g-recaptcha-response",o);try{const o=await fetch("https://www.luiztonin.com.br/canal-protecao-dados/ecom/enviar",{method:"POST",body:a}),s=await o.json();s&&s.mensagem?(alert(s.mensagem),s.success&&(e.target.reset(),window.grecaptcha.reset())):alert("Houve um erro ao enviar o formulário.")}catch(e){console.error("Error:",e),alert("Houve um erro ao enviar o formulário.")}finally{i(!1)}},children:[a.jsxs("div",{className:"form-box",children:[a.jsxs("select",{name:"tipoSolicitacao",id:"tipoSolicitacaoDPO",children:[a.jsx("option",{children:"Tipo de Solicitação"}),a.jsx("option",{value:"Confirmação de existência de tratamento",children:"Confirmação de existência de tratamento"}),a.jsx("option",{value:"Acesso aos dados",children:"Acesso aos dados"}),a.jsx("option",{value:"Correção aos dados",children:"Correção aos dados"}),a.jsx("option",{value:"Anonimização ou bloqueio dos dados desnecessários",children:"Anonimização ou bloqueio dos dados desnecessários"}),a.jsx("option",{value:"Eliminação dos dados",children:"Eliminação de dados"}),a.jsx("option",{value:"Portabilidade dos dados a outro fornecedor",children:"Portabilidade dos dados a outro fornecedor"}),a.jsx("option",{value:"Informação de compartilhamento de dados",children:"Informação de compartilhamento de dados"}),a.jsx("option",{value:"Informação sobre não fornecer consentimento",children:"Informação sobre não fornecer consentimento"}),a.jsx("option",{value:"Revogação do consentimento",children:"Revogação do consentimento"}),a.jsx("option",{value:"Oposição ao tratamento",children:"Oposição ao tratamento"})]}),a.jsx("input",{placeholder:"Qual sua cidade",id:"cidadeDPO",name:"cidade",type:"text",maxLength:"25",className:"validate js-only-letters-mask"}),a.jsx("input",{placeholder:"Insira seu nome",id:"nomeDPO",name:"nome",type:"text",maxLength:"50",className:"validate"}),a.jsx("input",{placeholder:"Insira seu CPF",id:"cpfDPO",name:"cpf",type:"text",className:"validate js-cpf-mask"}),a.jsx("input",{placeholder:"Qual seu e-mail?",id:"emailDPO",name:"email",type:"email",maxLength:"50",className:"validate"}),a.jsx("input",{placeholder:"Informe um telefone",id:"telefoneDPO",name:"telefone",type:"text",className:"validate js-mixed-phone-mask"}),a.jsx("textarea",{id:"mensagemDPO",name:"mensagem",placeholder:"Como podemos ajudar?",className:"materialize-textarea"})]}),a.jsxs("div",{className:"submit-container",children:[a.jsx("div",{className:"g-recaptcha","data-sitekey":"6LdRjiMgAAAAAOzpnItgWsi2a7EsOhR3TCFt4S1f","data-callback":"correctCaptcha"}),a.jsx("button",{type:"submit",className:"btn",children:"Enviar"})]})]}),a.jsx("p",{style:{margin:"30px 0"},children:a.jsxs("small",{children:["Para mais informações sobre seus dados pessoais, acesse nossa"," ",a.jsx("a",{href:"https://www.supertonin.com.br/politica_de_privacidade",children:"Política de Privacidade"})]})}),a.jsx("p",{style:{margin:"50px 0",textAlign:"justify",fontSize:"16px"},children:"Data de publicação: 29/01/2025"})]})]})}),a.jsx(t,{$show:o,id:"loader",children:a.jsx("div",{className:"loader__inner",children:a.jsx("div",{className:"loader__content",children:a.jsx("span",{className:"spinner"})})})})]})};